import React, { useEffect } from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { useHistory } from "react-router-dom";

const AboutUs = () => {
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    }
  }, []);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  return (
    <div className="Container">
      <div className="mobileContainer">
        <div className="AboutUsPage">
          <img
            src={require("../../assets/images/SplashLogo.png")}
            id="AboutImage"
          />
          <p id="BillHistory">
            سایت و اپلیکیشن کنتور در سال 98 و با پشتیبانی شرکت گنجینه زرین سپهر
            راه اندازی شد. هدف از راه اندازی این سایت ارائه خدمات اینترنتی و
            تسهیل امور روزمره اشخاص حقیقی و حقوقی در حوزه استعلام قبوض شرکت های
            خدماتی با توجه به حذف قبوض کاغذی بود که آنان را از مراجعه به شرکت ها
            و بانکها برای دریافت قبوض و پرداخت آنها بی نیاز می سازد ضمن اینکه با
            امکانات این سایت و اپلیکیشن مربوطه کاربران میتوانند ضمن دسترسی به
            آرشیو کامل پرداختی قبوض مختلف ، میزان مصرف آنها را هم مدیریت کنند.
            از ابتدای راه اندازی این سایت با استقبال گسترده کاربران مواجه شدیم و
            در حال حاضر روزانه تعداد زیادی قبوض مختلف توسط سامانه کنتور استعلام
            و پرداخت میگردد. همچنین بابت خدمات ارائه شده هیچگونه هزینه ای از
            کاربران دریافت نمی گردد.
          </p>
        </div>
        <PhoneHeader text={"درباره کنتور"} />
      </div>
    </div>
  );
};

export default AboutUs;
